module.exports = __webpack_public_path__ + "static/img/products_green enegry_mobile.a5bbff12.jpg";